export default class PropertyManagerData {
    public id: number;
    public firstName: string;
    public familyName: string;
    public roleId: number;

    constructor(
        id: number,
        firstName: string,
        familyName: string,
        roleId: number,
    ) {
        this.id = id;
        this.firstName = firstName;
        this.familyName = familyName;
        this.roleId = roleId;
    }
}
